<template>
  <form ref="driverVehicleRef">
    <div class="row">
      <div class="col-12">
        <div class="row">
          <div class="col-12 col-sm-6">
            <div class="form-group">
              <label for="companyName">{{ $t("driver") }}</label>
              <select
                v-model="driver"
                name="driver"
                class="form-control"
                id="driver"
                required
              >
                <option value="">{{ $t("select-driver") }}</option>
                <option value="orderDriver" v-if="orderDriver">
                  {{ orderDriver }}
                </option>
                <option
                  v-for="driver in availableDrivers"
                  :key="driver.id"
                  :value="driver.id"
                >
                  {{ driver.name }}
                </option>
              </select>
              <div class="font-12 gray4 mt-2">
                Driver not listed?
                <span
                  class="text-primary cursor-pointer"
                  @click="$emit('open_add_driver')"
                  >Add New Driver</span
                >
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-6">
            <div class="form-group">
              <label for="vehicle">{{ $t("assign_vehicle") }}</label>
              <select
                v-model="vehicle"
                name="vehicle"
                class="form-control"
                id="vehicle"
                required
                :disabled="driverHasVehicle"
                :class="{
                  'cursor-not-allowed': driverHasVehicle,
                  'cursor-pointer': !driverHasVehicle,
                }"
              >
                <option value="">{{ $t("select-vehicle") }}</option>
                <option value="orderVehicle" v-if="orderVehicle">
                  {{ orderVehicle }}
                </option>
                <option
                  v-for="vehicle in vehicles"
                  :key="vehicle.id"
                  :value="vehicle.id"
                  :disabled="assignedVehicles.includes(vehicle.id)"
                >
                  {{ vehicle.name }}
                </option>
              </select>
              <div class="font-12 gray4 mt-2">
                Vehicle not listed?
                <span
                  class="text-primary cursor-pointer"
                  @click="$emit('open_add_vehicle')"
                  >Add New Vehicle</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "DriverVehicleStep",
  props: {
    initialValues: {
      type: Object,
      default: () => ({}),
    },
    vehicleObj: {
      type: Object,
      default: () => ({}),
    },
    driverObj: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      driver: this.initialValues?.driver ?? "",
      vehicle: this.initialValues?.vehicle ?? "",
      orderDriver: null,
      orderVehicle: null,
    };
  },
  methods: {
    validateForm() {
      const form = this.$refs.driverVehicleRef;
      if (!form.checkValidity()) {
        form.reportValidity();
        return false;
      }
      return true;
    },
    getFormData() {
      return {
        driver: this.driver,
        vehicle: this.vehicle,
      };
    },
  },
  watch: {
    initialValues: {
      handler(newValues) {
        this.driver = newValues.driver || "";
        this.vehicle = newValues.vehicle || "";
      },
      deep: true,
    },
    driverObj: {
      handler(driver) {
        if (driver.name) {
          this.orderDriver = driver.name;
          this.driver = "orderDriver";
        }
      },
    },
    vehicleObj: {
      handler(vehicle) {
        if (vehicle.name) {
          this.orderVehicle = vehicle.name;
          this.vehicle = "orderVehicle";
        }
      },
    },
    driver: {
      handler(newVal) {
        if (newVal) {
          const driverObj = this.drivers.find((driver) => driver.id === newVal);
          if (driverObj?.assignedVehicleData?.id) {
            this.vehicle = driverObj.assignedVehicleData.id;
          } else {
            if (this.assignedVehicles.includes(this.vehicle)) {
              this.vehicle = "";
            }
          }
        }
      },
    },
  },
  computed: {
    ...mapGetters(["drivers", "vehicles"]),
    driverHasVehicle() {
      const driverObj = this.drivers.find(
        (driver) => driver.id === this.driver
      );
      return driverObj?.assignedVehicleData?.id;
    },
    availableDrivers() {
      return this.drivers.filter((driver) => driver.isActive);
    },
    assignedVehicles() {
      return this.drivers
        .filter((driver) => driver?.assignedVehicleData?.id)
        .map((driver) => driver.assignedVehicleData.id);
    },
  },
};
</script>
